<template>
    <!--콘텐츠 영역-->
    <div id="sub_contents" class="sub_contents history">
        <div class="item">
            <div class="tit">
                <h3>송원 문화재단이<br> 걸어온 길</h3>
                <p class="tit_sub">
                    1996년부터 지금까지,<br>
                    다양한 장학사업과<br>
                    문화예술활동을 꾸준히<br>
                    확대해나가고 있습니다.
                </p>
                <div class="chairman">
                    <img :src="require('./../../assets/img/chairman.png')">
                    <p>재단을 설립하신 장상태 초대 이사장님</p>
                </div>
            </div>

            <ul class="history_frame">
                <li>
                    <h5 class="history_tit">2023년</h5>
                    <p class="history_txt">
                        <span>제20기 &lt;송원 이공계 장학생&gt; 선발</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2021년</h5>
                    <p class="history_txt">
                        <span>‘에스모드서울재단’ 장학금 지정기탁 협약</span><br/>
                        <span>온택트 비대면 장학증서 수여식 개최</span>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2019년</h5>
                    <p class="history_txt">
                        <span>‘부산남구드림스타트’, ‘감만종합사회복지관’ 연계 부산지역 초중고교 장학생 선발</span><br/>
                        <span>제 3대 장세욱 이사장 취임</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2016년</h5>
                    <p class="history_txt">
                        <span>‘유니온스틸 장학회’ 흡수 합병</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2014년</h5>
                    <p class="history_txt">
                        <span>지역복지사업 누계액 20억원 달성</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2013년</h5>
                    <p class="history_txt">
                        <span>장학사업 누계액 50억원 달성</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2012년</h5>
                    <p class="history_txt">
                        <span>‘한국메세나협회’ 가입</span><br/>
                        <span>송원아트센터 신축 재개관</span>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2009년</h5>
                    <p class="history_txt">
                        <span>‘사단법인 캔파운데이션’ &lt;아트버스 프로젝트&gt; 후원 협약</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2006년</h5>
                    <p class="history_txt">
                        <span>송원아트센터(종로구 화동) 개관전시</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2005년</h5>
                    <p class="history_txt">
                        <span>목적사업에 문화예술사업 추가</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2004년</h5>
                    <p class="history_txt">
                        <span>제 1기 &lt;송원 이공계 장학생&gt; 선발</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2002년</h5>
                    <p class="history_txt">
                        <span>장학사업 누계액 20억원 달성</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">2001년</h5>
                    <p class="history_txt">
                        <span>명칭변경 ‘대원문화재단’ → ‘송원문화재단’</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">1998년</h5>
                    <p class="history_txt">
                        <span>제 2대 추경석 이사장 취임</span><br/>
                    </p>
                </li>
                <li>
                    <h5 class="history_tit">1996년</h5>
                    <p class="history_txt">
                        <span>재단 설립</span><br/>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    data: () => ({
        message: "History.vue"
    }),
    methods: {},
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    destroyed() { },
    created() {
        console.log("created - " + this.message);
    }
};
</script>

<style></style>
 


// WEBPACK FOOTER //
// src/components/sub03/History.vue